import React, {useCallback, useEffect, useMemo} from 'react';
import DidiSelectionCommonColumn from "../common-column";
import {tabColIconSucOrErrMap} from "consts";
import {useValueAddedPrice} from "hooks/product-price/value-added-price";


interface IComponentProps {
  data?: any
}
const ValueAddServiceTemplateColumn: React.FC<IComponentProps> = (props) => {
  const { data } = props
  const { tableActionEdit } = useValueAddedPrice()
  const {
    insurance_rule_vip_code,
    insurance_rule_vip_name	,
    insurance_rule_vip_ok,
    insurance_rule_vip_price
  } = data

  const imgUrl = useMemo(() => {
    return tabColIconSucOrErrMap[insurance_rule_vip_ok]
  }, [insurance_rule_vip_ok])

  const editFn = useCallback(() => {
    tableActionEdit({
      rule_code: insurance_rule_vip_code
    })
  }, [
    insurance_rule_vip_code
  ])

  useEffect(() => {


  }, []);

  return (
    insurance_rule_vip_code ? <DidiSelectionCommonColumn
      editFn={editFn}
      name={`${insurance_rule_vip_name}：${insurance_rule_vip_price / 100}元`}
      imgUrl={imgUrl}/> : null
  );
};

export default ValueAddServiceTemplateColumn;
